import {SET_AUTH} from 'services/graphql/auth';

// graphql_jwt's replies to a token it can't use, e.g. one signed with a rotated SECRET_KEY (SEC-19).
export const STALE_TOKEN_ERRORS = [
  "Error decoding signature",
  "Invalid token",
  "Invalid payload",
  "Signature has expired",
];

export const isStaleTokenError = (message) => STALE_TOKEN_ERRORS.includes(message);

// Called with each GraphQL error. On PermissionDenied or a stale token, forget the stored tokens and mark the app
// logged out. A stale token fails on every request, so that case also goes straight to the login page.
export const handleAuthError = (message, cache, location = window.location, storage = window.localStorage) => {
  const stale = isStaleTokenError(message);
  if (message !== "PermissionDenied" && !stale) {
    return false;
  }
  storage.removeItem('authToken');
  storage.removeItem('refreshToken');
  cache.writeQuery({
    query: SET_AUTH,
    data: {
      auth: {
        isAuth: false,
        __typename: 'Auth'
      }
    }
  });
  if (stale && !location.pathname.startsWith('/auth/login')) {
    location.replace('/auth/login/');
  }
  return true;
};
